<template>
    <div>
        <rkm-table
            :fields="fields.table"
            :filter="filter"
            :items="form.historico"
            thead-class="d-none"
            hide-filters
        >
            <template v-slot:filters>
                <rkm-col cols="12" class="px-0">
                    <rkm-form-input
                        placeholder="Digite para buscar"
                        v-model="filter"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                Buscar
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    :options="[
                                        { value: valueShowHistorico.LAST_SIX_MONTHS, text: 'Últimos 6 meses' },
                                        { value: valueShowHistorico.COMPLETE, text: 'Completo' }
                                    ]"
                                    v-model="showHistorico"
                                />
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </template>

            <template v-slot:cell(dataDispensacao)="{ item }">
                <strong>Data da receita: </strong>
                <p>{{ item.dataDispensacao }}</p>
            </template>

            <template v-slot:cell(unidade)="{ item }">
                <strong>Unidade/Local de atendimento: </strong>
                <p>{{ `${item.nomeFantasia} / ${item.infraestrutura}`  }}</p>
            </template>

            <template v-slot:cell(medicoSolicitante)="{ item }">
                <strong>Médico solicitante: </strong>
                <p>{{ item.medicoSolicitante }}</p>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.observacao ? 'info' : 'secondary'"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Observação',
                        html:true,
                        content: item.observacao
                            ? item.observacao
                            : 'Nenhuma observação informada.',
                    }"
                >
                    <i class="fas fa-comment-alt"></i>
                </rkm-button>

                <rkm-button
                    :disabled="!item.items.find(i => !i.estornado)"
                    @click="imprimir(item.id)"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <template #row-details="{ item }">
                <rkm-table
                    :fields="fields.detail"
                    :items="item.items"
                    :tbody-tr-class="rowClass"
                    class="table-historico"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot:cell(lotes)="row">
                        <div v-for="lote in row.item.lotes" :key="lote">
                            {{ lote }}
                        </div>
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            v-if="!item.estornado || item.estornoSalvo"
                            :disabled="!!item.estornado"
                            :title="!!item.estornado ? 'Estornado' : 'Estornar'"
                            @click="handleEstorno(item)"
                            color="danger"
                            small
                        >
                            <rkm-icon icon="undo-alt" />
                        </rkm-button>

                        <rkm-button
                            v-else
                            title="Cancelar estorno"
                            @click="handleCancelEstorno(item)"
                            color="danger"
                            small
                        >
                            <rkm-icon icon="times" />
                        </rkm-button>
                    </template>

                    <template #afterPagination>
                        <div class="mt-2">
                            <rkm-row>
                                <rkm-col>
                                    <p class="m-0">A linha em <span class="red">vermelho</span> representa que a dispensação foi estornada.</p>
                                </rkm-col>
                            </rkm-row>
                        </div>
                    </template>
                </rkm-table>
            </template>
        </rkm-table>
    </div>
</template>

<script>
import { file, repository, error, request, printAlmoxarifado } from '@/mixins'
import { mapActions } from 'vuex'
import moment from 'moment';

export default {
    created() {
        this.repositories = {
            dispensacaoMateriais: this.getConectaSusRepository('almoxarifado.dispensacaoMateriais'),
            balancete: this.getConectaSusRepository('almoxarifado.balancete')
        }
        this.showHistorico = this.valueShowHistorico.LAST_SIX_MONTHS
        this.addWatcherHistorico()
    },
    computed: {
        fields() {
            return  {
                table: [
                    {key: 'dataDispensacao', label: 'Data da dispensação', sortable: true },
                    {key: 'unidade', label: 'Unidade/Local de atendimento', sortable: true },
                    {key: 'medicoSolicitante', label: 'Médico solicitante', sortable: true },
                    {key: 'actions', label: 'Ações', class: 'col-min' },
                ],
                detail: [
                    {key: 'dispensadoEm', label: 'Dispensação', sortable: true },
                    {key: 'usuarioNome', label: 'Usuário', sortable: true },
                    {key: 'material.descricao', label: 'Material', sortable: true },
                    {key: 'lotes', label: 'Lote', sortable: true, class:'text-center' },
                    {key: 'quantidade', label: 'Quantidade', sortable: true, class:'text-center' },
                    {key: 'actions', label: 'Ações', class: 'col-min text-center'},
                ]
            }
        },
        valueShowHistorico() {
            return {
                LAST_SIX_MONTHS: 0,
                COMPLETE: 1
            }
        },
    },
    data: () => ({
        showHistorico: null,
        filter: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        addWatcherHistorico() {
            this.$watch('showHistorico', function() {
                this.getHistorico()
            })
        },
        imprimir(id) {
            if(id) {
                this.setLoading()
                this.repositories.dispensacaoMateriais.print(id)
                    .then(({ data }) => {
                        this.handlePrint(data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        getHistorico() {
            this.setLoading()
            this.repositories.dispensacaoMateriais.getHistorico(
                    this.form.paciente.id,
                    { complete: this.showHistorico == this.valueShowHistorico.COMPLETE })
                .then(({ data }) => {
                    this.setShowDetails(data)
                    this.form.historico = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePrint(data) {
            let printData = {
                medicoNome: data.nomeMedicoSolicitante,
                materiais: data.itens,
                pacienteNome: this.form.paciente.cidadao.nome,
                pacienteNomeSocial: this.form.paciente.cidadao.nomeSocial,
                prontuario: this.form.paciente.prontuario,
                dataNascimento: this.form.paciente.cidadao.dataNascimento.split("-").reverse().join("/"),
                dataAtual: this.form.dataAtual,
                dataEntrega: data.dispensadoEm,
                horaAtendimento: data.horaAtendimento,
                logotipo: this.form.cliente.logotipo,
                nomePrefeitura: this.form.cliente.nome,
                ramoAtividade: this.form.cliente.sistema.ramoAtividade.nome,
                sistemaNome: this.form.cliente.sistema.nome,
                sistemaVersao: this.form.cliente.sistema.versao,
                usuario: this.form.usuario,
                unidade: this.form.unidade,
                telefone: this.form.telefone,
            }
            this.print().dispensacao(printData)
        },
        handleEstorno(item) {
            this.setLoading()
            this.repositories.balancete.checkDate(moment(item.dispensadoEm, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                .then(({ data }) => {
                    if(!data.mesFechado) {
                        this.showDeleteConfirmation(
                            'Deseja realmente estornar a dispensação?',
                            async () => item.estornado = true
                        )
                        return
                    }
                    this.showValidationNotification(
                        'A data da dispensação corresponde a um mês já finalizado. Estorno não permitido.'
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCancelEstorno(item) {
            this.showDeleteConfirmation(
                'Deseja realmente cancelar o estorno?',
                async () => item.estornado = false
            )
        },
        rowClass(item, type) {
            if (type === 'row' && item && !!item.estornado) {
                return 'table-danger'
            }
        }
    },
    mixins: [ file, repository, error, request, printAlmoxarifado ],
    props: {
        form: { type: Object, default: null },
    }
}
</script>

<style scoped>
.table-historico >>> .red { color: red; }
</style>